import { createAnalyticsGroup } from 'js/lib/analytics'

if (document.querySelectorAll('.js-c-pages-landing-big-dogs').length) {
  document.querySelectorAll('.js-analytics-tracking').forEach(el => {
    const track = createAnalyticsGroup('BigDogsLandingPage')

    const label = el.getAttribute('data-analytics-label') || 'unknown link'
    el.addEventListener('click', () => {
      track('click', label)
    })
  })
}
